module.exports = __webpack_public_path__ + "static/nicole-9b40357821200f0ec086b376aa96e6a6.jpeg";